import React from 'react'
import {compose} from 'recompose'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withData from '../../../elements/Select/withData'

const GroupTypeSelect = compose(
  withData({
    data: [
      {
        key: 'Department',
        value: 'Department',
      },
      {
        key: 'Group',
        value: 'Group',
      },
    ],
  }),
)(CustomSelect)

export default GroupTypeSelect
